/* ==========================================================================
   Vantagehaul — comportamiento propio. Sin librerías externas.
   Cada init comprueba si su elemento existe, así el archivo sirve para
   todas las páginas del tema.
   ========================================================================== */

(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------------
     El botón de añadir al carro de la ficha de producto lleva un icono fijo
     más un `<span data-hp-add-label>` con el texto. Si se le hace
     `textContent = ...` al botón entero (como antes), se borra el icono de
     paso. Estas dos funciones leen/escriben SOLO el span cuando existe, y
     si no (el botón del hero de portada no lo tiene), caen al botón entero
     como hacía siempre. */
  function getAddLabel(btn) {
    if (!btn) return '';
    var label = btn.querySelector('[data-hp-add-label]');
    return label ? label.textContent : btn.textContent;
  }

  function setAddLabel(btn, text) {
    if (!btn) return;
    var label = btn.querySelector('[data-hp-add-label]');
    if (label) {
      label.textContent = text;
    } else {
      btn.textContent = text;
    }
  }

  /* ---------------------------------------------------------------- Reveals */

  function initReveals() {
    var items = document.querySelectorAll('.hp-reveal');
    if (!items.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('hp-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('hp-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    for (var j = 0; j < items.length; j++) observer.observe(items[j]);

    // Red de seguridad: si el navegador no dispara el observador (pestaña en
    // segundo plano, motor sin composición, extensión que interfiere...), el
    // contenido NUNCA debe quedarse invisible. Antes esto solo se comprobaba
    // una vez a los 1200ms, así que solo salvaba lo que ya estaba cerca de
    // arriba en ese instante — cualquier sección más abajo en la página se
    // quedaba invisible para siempre si el observer fallaba. Ahora también
    // se repite en cada scroll/resize (con límite de frecuencia), hasta que
    // no quede nada pendiente.
    function revealPending() {
      var pending = document.querySelectorAll('.hp-reveal:not(.hp-visible)');
      if (!pending.length) return true;
      for (var k = 0; k < pending.length; k++) {
        var box = pending[k].getBoundingClientRect();
        if (box.top < window.innerHeight * 1.2) pending[k].classList.add('hp-visible');
      }
      return document.querySelectorAll('.hp-reveal:not(.hp-visible)').length === 0;
    }

    window.setTimeout(revealPending, 1200);

    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.setTimeout(function () {
        ticking = false;
        if (revealPending()) {
          window.removeEventListener('scroll', onScrollOrResize);
          window.removeEventListener('resize', onScrollOrResize);
        }
      }, 150);
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
  }

  /* -------------------------------------------------- Hero: escala de entrada */

  function initHero() {
    var hero = document.querySelector('.hp-hero');
    if (!hero) return;
    requestAnimationFrame(function () {
      hero.classList.add('hp-in');
    });
  }

  /* ------------------------------------------------------- Cifras animadas */

  function initCounters() {
    var nums = document.querySelectorAll('[data-hp-count]');
    if (!nums.length) return;

    function paint(el, value) {
      var decimals = parseInt(el.dataset.hpDecimals || '0', 10);
      el.textContent =
        (el.dataset.hpPrefix || '') + value.toFixed(decimals) + (el.dataset.hpSuffix || '');
    }

    function run(el) {
      var target = parseFloat(el.dataset.hpCount);
      if (isNaN(target)) return;
      if (REDUCED) {
        paint(el, target);
        return;
      }
      var duration = 1500;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        paint(el, target * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < nums.length; i++) run(nums[i]);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          run(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.5 }
    );

    for (var j = 0; j < nums.length; j++) observer.observe(nums[j]);
  }

  /* -------------------------------------------- Comparador antes / después */

  function initCompare() {
    var stages = document.querySelectorAll('.hp-compare__stage');
    if (!stages.length) return;

    Array.prototype.forEach.call(stages, function (stage) {
      var dragging = false;

      function setFromClientX(clientX) {
        var rect = stage.getBoundingClientRect();
        if (!rect.width) return;
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        stage.style.setProperty('--hp-split', pct + '%');
      }

      stage.addEventListener('pointerdown', function (e) {
        dragging = true;
        stage.setPointerCapture(e.pointerId);
        setFromClientX(e.clientX);
      });

      stage.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setFromClientX(e.clientX);
      });

      function stop(e) {
        if (!dragging) return;
        dragging = false;
        try {
          stage.releasePointerCapture(e.pointerId);
        } catch (err) {
          /* el navegador ya lo soltó */
        }
      }

      stage.addEventListener('pointerup', stop);
      stage.addEventListener('pointercancel', stop);

      stage.addEventListener('keydown', function (e) {
        var current = parseFloat(stage.style.getPropertyValue('--hp-split')) || 50;
        if (e.key === 'ArrowLeft') {
          stage.style.setProperty('--hp-split', Math.max(0, current - 4) + '%');
          e.preventDefault();
        } else if (e.key === 'ArrowRight') {
          stage.style.setProperty('--hp-split', Math.min(100, current + 4) + '%');
          e.preventDefault();
        }
      });
    });
  }

  /* ------------------------------------------------- Galería de la ficha */

  function initGallery() {
    var gallery = document.querySelector('[data-hp-gallery]');
    if (!gallery) return;

    var slides = gallery.querySelectorAll('.hp-gallery__slide');
    var thumbs = gallery.querySelectorAll('.hp-gallery__thumb');
    var prevBtn = gallery.querySelector('[data-hp-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-hp-gallery-next]');
    var main = gallery.querySelector('.hp-gallery__main');
    var caption = gallery.querySelector('[data-hp-gallery-caption]');
    if (!slides.length) return;

    var actual = 0;

    // El pie de foto es literalmente el `alt` de la imagen activa — así
    // no hay que mantener una segunda lista de nombres en JS, si el alt
    // de Shopify cambia el pie cambia solo con él.
    function updateCaption() {
      if (!caption) return;
      var img = slides[actual] && slides[actual].querySelector('img');
      caption.textContent = img && img.alt ? img.alt : '';
    }

    function show(index, scrollThumb) {
      actual = (index + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('hp-active', i === actual);
      }
      for (var j = 0; j < thumbs.length; j++) {
        thumbs[j].classList.toggle('hp-active', j === actual);
        thumbs[j].setAttribute('aria-selected', j === actual ? 'true' : 'false');
      }
      updateCaption();
      // En móvil ninguno de los dos scrolls de aquí abajo debe moverla
      // pantalla: con la rejilla de modelos, el cliente ya está mirando
      // su propio desplegable (más abajo en la página) al elegir — subir
      // la pantalla de golpe hasta la foto o la miniatura lo saca de
      // donde está mirando. La foto sigue cambiando igual, solo no
      // arrastra la vista con ella.
      var isMobileViewport = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      // Al elegir un color desde las tarjetas de arriba, la tira de
      // miniaturas de debajo de la foto principal también se desplaza
      // hasta esa foto, igual que el selector de referencia.
      if (scrollThumb && thumbs[actual] && thumbs[actual].scrollIntoView && !isMobileViewport) {
        thumbs[actual].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
      // Sube la página para que se vea la foto GRANDE, no solo la
      // miniatura: antes el objetivo del scroll era la miniatura con
      // block:'nearest', que apenas movía la página y la foto grande se
      // quedaba fuera de la pantalla. Solo pasa al elegir color — la
      // talla no cambia la foto, así que no debe mover nada (lo decide
      // quien llama a refreshUnit/show, pasando showInGallery a false).
      if (scrollThumb && main && main.scrollIntoView && !isMobileViewport) {
        main.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    // Al cargar la página la primera foto ya está activa por HTML (Liquid
    // pinta la 1ª con hp-active), así que el pie de foto necesita este
    // empujón inicial — show() solo se llama luego, con la interacción.
    updateCaption();

    Array.prototype.forEach.call(thumbs, function (thumb, index) {
      thumb.addEventListener('click', function () {
        show(index);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { show(actual - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(actual + 1); });

    // Navegar con la rueda del ratón sobre la imagen principal. Solo
    // reacciona a gestos claramente horizontales/verticales dedicados a la
    // galería para no robarle el scroll normal de la página al usuario.
    if (main && slides.length > 1) {
      var ruedaOcupada = false;
      main.addEventListener(
        'wheel',
        function (e) {
          if (ruedaOcupada) {
            e.preventDefault();
            return;
          }
          if (Math.abs(e.deltaY) < 12 && Math.abs(e.deltaX) < 12) return;
          e.preventDefault();
          show(actual + (e.deltaY > 0 || e.deltaX > 0 ? 1 : -1));
          ruedaOcupada = true;
          window.setTimeout(function () {
            ruedaOcupada = false;
          }, 350);
        },
        { passive: false }
      );
    }

    gallery.hpShowImage = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === String(mediaId)) {
          show(i, true);
          return;
        }
      }
    };

    // Flechas de la tira de miniaturas (solo visibles en móvil, ver CSS):
    // avanzan la tira una "página" (su propio ancho visible), no cambian
    // la foto grande — el deslizar con el dedo ya hace eso mismo de forma
    // nativa gracias al scroll-snap, esto es solo la alternativa a clic.
    var thumbsTrack = gallery.querySelector('[data-hp-thumbs-track]');
    var thumbsPrev = gallery.querySelector('[data-hp-thumbs-prev]');
    var thumbsNext = gallery.querySelector('[data-hp-thumbs-next]');
    if (thumbsTrack && thumbsPrev && thumbsNext) {
      var deslizarTira = function (direccion) {
        thumbsTrack.scrollBy({ left: thumbsTrack.clientWidth * direccion, behavior: 'smooth' });
      };
      thumbsPrev.addEventListener('click', function () { deslizarTira(-1); });
      thumbsNext.addEventListener('click', function () { deslizarTira(1); });
    }
  }

  /* --------------------------------- Sonido opcional en la cuadrícula de vídeos */

  // Solo se activa en dispositivos con "hover" de verdad (ratón). En
  // táctil no se enganchan ni los listeners, así que en móvil los vídeos
  // se quedan mudos siempre — no basta con el CSS `@media (hover: none)`
  // que solo oculta el control, esto además evita cualquier sonido
  // accidental si algún navegador táctil sí dispara eventos de hover.
  //
  // A propósito, pasar el ratón por encima NO activa el sonido por sí
  // solo (solo enseña la barra) — hay que tocar el altavoz o mover el
  // slider. Y al salir del vídeo el sonido NO se corta: si el cliente lo
  // subió, sigue sonando aunque quite el ratón. Si hace eso en varios
  // vídeos a la vez, se solapan sus sonidos — es el comportamiento
  // esperado, no un fallo.
  function initVideoWallSound() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

    var tiles = document.querySelectorAll('[data-hp-video-tile]');
    if (!tiles.length) return;

    Array.prototype.forEach.call(tiles, function (tile) {
      var video = tile.querySelector('.hp-videowall__video');
      var slider = tile.querySelector('[data-hp-video-volume-slider]');
      var muteBtn = tile.querySelector('[data-hp-video-mute]');
      if (!video || !slider || !muteBtn) return;

      video.volume = parseFloat(slider.value);

      function sincronizarIcono() {
        muteBtn.classList.toggle('is-muted', video.muted);
      }

      muteBtn.addEventListener('click', function () {
        // Si estaba mudo y el volumen se había quedado a 0 (por ejemplo,
        // arrastrando el slider hasta el final), al desmutear con el
        // icono se restaura un volumen audible en vez de desmutear a 0,
        // que sonaría igual de silencioso.
        if (video.muted && video.volume <= 0) {
          video.volume = 0.6;
          slider.value = '0.6';
        }
        video.muted = !video.muted;
        sincronizarIcono();
      });

      slider.addEventListener('input', function () {
        var v = parseFloat(slider.value);
        video.volume = v;
        video.muted = v <= 0;
        sincronizarIcono();
      });
    });
  }

  /* -------------------------------- Carrusel de reseñas de la ficha de producto */

  function initProductReviews() {
    var boxes = document.querySelectorAll('[data-hp-pdp-reviews]');
    if (!boxes.length) return;

    Array.prototype.forEach.call(boxes, function (box) {
      var slides = box.querySelectorAll('.hp-pdp__review');
      var prevBtn = box.querySelector('[data-hp-pdp-review-prev]');
      var nextBtn = box.querySelector('[data-hp-pdp-review-next]');
      if (slides.length < 2) return;

      var actual = 0;

      function show(index) {
        actual = (index + slides.length) % slides.length;
        for (var i = 0; i < slides.length; i++) {
          slides[i].classList.toggle('hp-active', i === actual);
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { show(actual - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(actual + 1); });
    });
  }

  /* --------------------------------------------- Variantes + añadir al carro */

  function initVariants() {
    var pickers = document.querySelectorAll('[data-hp-variants]');
    if (!pickers.length) return;
    Array.prototype.forEach.call(pickers, initOneVariantPicker);
  }

  function initOneVariantPicker(picker) {
    // Todo lo relacionado vive dentro del mismo "cajón de compra", así puede
    // haber varios en la misma página sin pisarse.
    var box = picker.closest('[data-hp-buybox]') || document;

    var buttons = picker.querySelectorAll('.hp-variant');
    var idInput = box.querySelector('[data-hp-variant-id]');
    // Puede haber varios sitios mostrando lo mismo (el cajón y la barra fija),
    // así que se actualizan TODOS, no solo el primero.
    var pricesNow = box.querySelectorAll('[data-hp-price-now]');
    var chosenAll = box.querySelectorAll('[data-hp-chosen]');
    var priceWas = box.querySelector('[data-hp-price-was]');
    var saveTag = box.querySelector('[data-hp-save]');
    var addBtn = box.querySelector('[data-hp-add]');
    var gallery = box.querySelector('[data-hp-gallery]');

    function setAll(list, value) {
      for (var i = 0; i < list.length; i++) list[i].textContent = value;
    }

    function select(btn) {
      if (btn.classList.contains('hp-soldout')) return;

      for (var i = 0; i < buttons.length; i++) {
        buttons[i].classList.toggle('hp-active', buttons[i] === btn);
        buttons[i].setAttribute('aria-checked', buttons[i] === btn ? 'true' : 'false');
      }

      if (idInput) idInput.value = btn.dataset.variantId;
      setAll(pricesNow, btn.dataset.price);
      setAll(chosenAll, btn.dataset.name);

      if (priceWas) {
        if (btn.dataset.compare) {
          priceWas.textContent = btn.dataset.compare;
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }

      if (saveTag) {
        if (btn.dataset.save) {
          saveTag.textContent = btn.dataset.save;
          saveTag.hidden = false;
        } else {
          saveTag.hidden = true;
        }
      }

      if (addBtn) {
        addBtn.disabled = false;
        setAddLabel(addBtn, addBtn.dataset.labelAdd || 'Add to cart');
      }

      if (gallery && gallery.hpShowImage && btn.dataset.mediaId) {
        gallery.hpShowImage(btn.dataset.mediaId);
      }

      if (
        picker.dataset.syncUrl === 'true' &&
        window.history &&
        window.history.replaceState &&
        btn.dataset.variantId
      ) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', btn.dataset.variantId);
        window.history.replaceState({}, '', url.toString());
      }
    }

    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function () {
        select(btn);
      });
    });

    // Selección inicial: la de la URL si existe y está disponible.
    var params = new URLSearchParams(window.location.search);
    var wanted = picker.dataset.syncUrl === 'true' ? params.get('variant') : null;
    var initial = null;

    if (wanted) {
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].dataset.variantId === wanted && !buttons[i].classList.contains('hp-soldout')) {
          initial = buttons[i];
          break;
        }
      }
    }

    if (!initial) {
      for (var j = 0; j < buttons.length; j++) {
        if (!buttons[j].classList.contains('hp-soldout')) {
          initial = buttons[j];
          break;
        }
      }
    }

    if (initial) {
      select(initial);
    } else if (addBtn) {
      addBtn.disabled = true;
      setAddLabel(addBtn, addBtn.dataset.labelSoldout || 'Sold out');
    }
  }

  /* --------------------------------- Color (fotos) + Talla, ficha de producto */

  var hpDropdownGlobalsBound = false;
  function bindDropdownGlobalsOnce() {
    if (hpDropdownGlobalsBound) return;
    hpDropdownGlobalsBound = true;
    // Un único listener para toda la página, en vez de uno nuevo cada vez
    // que se reconstruye un desplegable (si no, se acumulan por cada
    // cambio de oferta y la página se vuelve cada vez más lenta).
    document.addEventListener('click', function (e) {
      Array.prototype.forEach.call(document.querySelectorAll('.hp-dd'), function (dd) {
        if (!dd.contains(e.target) && dd.hpCloseDropdown) dd.hpCloseDropdown();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        Array.prototype.forEach.call(document.querySelectorAll('.hp-dd'), function (dd) {
          if (dd.hpCloseDropdown) dd.hpCloseDropdown();
        });
      }
    });
  }

  function wireDropdown(dd) {
    var trigger = dd.querySelector('[data-hp-dd-trigger]');
    var list = dd.querySelector('[data-hp-dd-list]');
    if (!trigger || !list) return;

    function close() {
      list.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }
    function open() {
      Array.prototype.forEach.call(document.querySelectorAll('.hp-dd__list'), function (l) {
        if (l !== list) l.hidden = true;
      });
      list.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (list.hidden) open(); else close();
    });
    dd.hpCloseDropdown = close;
  }

  /* --------------------------------------- Ofertas por cantidad (1 / 2 / 3) */

  function initOffers() {
    var groups = document.querySelectorAll('[data-hp-offers]');
    if (!groups.length) return;

    Array.prototype.forEach.call(groups, function (group) {
      bindDropdownGlobalsOnce();

      // El precio tachado lo pinta Liquid con el filtro `money`, que usa
      // coma decimal en euros/coronas y punto en dólares/soles según la
      // moneda del visitante. El precio final de abajo lo calculamos en JS
      // y siempre lleva punto (formatPrice usa toFixed). Para que ambos
      // números se vean con el mismo formato, aquí normalizamos SOLO el
      // separador decimal final (coma + 2 dígitos justo antes del símbolo
      // de moneda o del final del texto) a punto, sin tocar un posible
      // punto de millar si lo hubiera.
      Array.prototype.forEach.call(group.querySelectorAll('.hp-offer__was'), function (el) {
        el.textContent = el.textContent.replace(/,(\d{2})(\D*)$/, '.$1$2');
      });

      var box = group.closest('[data-hp-buybox]') || document;
      var jsonEl = box.querySelector('[data-hp-variants-json]');
      var variants = [];
      if (jsonEl) {
        try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }
      }

      var colorLabel = group.dataset.colorLabel || 'Color';
      var tallaLabel = group.dataset.tallaLabel || 'Talla';
      var colorValues = [];
      var tallaValues = [];
      variants.forEach(function (v) {
        if (colorValues.indexOf(v.color) === -1) colorValues.push(v.color);
        if (tallaValues.indexOf(v.talla) === -1) tallaValues.push(v.talla);
      });

      var idInput = box.querySelector('[data-hp-variant-id]');
      var pricesNow = box.querySelectorAll('[data-hp-price-now]');
      var addBtn = box.querySelector('[data-hp-add]');
      var gallery = box.querySelector('[data-hp-gallery]');
      var qtyInput = box.querySelector('[data-hp-quantity]');
      var offerCards = group.querySelectorAll('[data-hp-offer-card]');
      var basePrice = 0;
      var units = [];

      function setAll(list, value) { for (var i = 0; i < list.length; i++) list[i].textContent = value; }

      function findVariant(color, talla) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].color === color && variants[i].talla === talla) return variants[i];
        }
        return null;
      }
      function firstAvailableTalla(color) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].color === color && variants[i].available) return variants[i].talla;
        }
        for (var j = 0; j < variants.length; j++) {
          if (variants[j].color === color) return variants[j].talla;
        }
        return tallaValues[0];
      }
      function firstAvailableColor() {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].available) return variants[i].color;
        }
        return colorValues[0];
      }
      function markActive(list, currentValue) {
        Array.prototype.forEach.call(list.querySelectorAll('.hp-dd__option'), function (opt) {
          var span = opt.querySelector('span:last-child');
          opt.classList.toggle('hp-active', !!span && span.textContent === currentValue);
        });
      }

      function buildDropdown(kind, onPick, initialValue) {
        var wrap = document.createElement('div');
        wrap.className = 'hp-dd';

        var trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'hp-dd__trigger';
        // Sin este atributo, wireDropdown() no encuentra el disparador y el
        // desplegable se dibuja pero no abre al hacer clic.
        trigger.setAttribute('data-hp-dd-trigger', '');
        trigger.setAttribute('aria-haspopup', 'listbox');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-label', kind === 'color' ? colorLabel : tallaLabel);

        var thumbEl = null;
        if (kind === 'color') {
          thumbEl = document.createElement('span');
          thumbEl.className = 'hp-dd__thumb';
          trigger.appendChild(thumbEl);
        }

        var valueEl = document.createElement('span');
        valueEl.className = 'hp-dd__value';
        valueEl.textContent = initialValue || '';
        trigger.appendChild(valueEl);

        var caret = document.createElement('span');
        caret.className = 'hp-dd__caret';
        caret.setAttribute('aria-hidden', 'true');
        caret.innerHTML = '<svg viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        trigger.appendChild(caret);
        wrap.appendChild(trigger);

        var list = document.createElement('ul');
        list.className = 'hp-dd__list';
        list.setAttribute('data-hp-dd-list', '');
        list.setAttribute('role', 'listbox');
        list.hidden = true;

        var values = kind === 'color' ? colorValues : tallaValues;
        values.forEach(function (val) {
          var li = document.createElement('li');
          li.setAttribute('role', 'option');
          var optBtn = document.createElement('button');
          optBtn.type = 'button';
          optBtn.className = 'hp-dd__option';

          if (kind === 'color') {
            var rep = variants.filter(function (v) { return v.color === val; })[0];
            var t = document.createElement('span');
            t.className = 'hp-dd__thumb';
            if (rep && rep.image) {
              var img = document.createElement('img');
              img.src = rep.image;
              img.alt = '';
              img.loading = 'lazy';
              img.width = 26;
              img.height = 26;
              t.appendChild(img);
            }
            optBtn.appendChild(t);
          }
          var span = document.createElement('span');
          span.textContent = val;
          optBtn.appendChild(span);
          optBtn.addEventListener('click', function () {
            // El de Talla se cierra al elegir (como antes). El de Diseño
            // se queda abierto para poder ir mirando varios colores
            // seguidos — solo se cierra al clicar fuera o al volver a
            // pulsar su propio botón.
            if (kind !== 'color' && wrap.hpCloseDropdown) wrap.hpCloseDropdown();
            onPick(val);
          });
          li.appendChild(optBtn);
          list.appendChild(li);
        });
        wrap.appendChild(list);
        wireDropdown(wrap);

        return { wrap: wrap, trigger: trigger, list: list, valueEl: valueEl, thumbEl: thumbEl };
      }

      // Rejilla de fotos para el Diseño/Color: con tantos modelos (18) un
      // desplegable con nombres se vuelve poco intuitivo — mejor ver todas
      // las fotos de golpe, en varias filas de ~3-4, y marcar la elegida
      // con un borde azul. Sin nombres de texto dentro de la rejilla (el
      // pie de foto grande de la galería, cuando se toca una imagen, ya
      // cumple esa función) — pero la rejilla en sí sigue escondida hasta
      // que el cliente pulsa el propio desplegable, igual que antes: es un
      // `.hp-dd` más, solo que su lista es la rejilla de fotos en vez de
      // filas de texto.
      function buildColorGrid(onPick, initialValue) {
        var wrap = document.createElement('div');
        wrap.className = 'hp-dd';

        var trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'hp-dd__trigger';
        trigger.setAttribute('data-hp-dd-trigger', '');
        trigger.setAttribute('aria-haspopup', 'listbox');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-label', colorLabel);

        var thumbEl = document.createElement('span');
        thumbEl.className = 'hp-dd__thumb';
        trigger.appendChild(thumbEl);

        var valueEl = document.createElement('span');
        valueEl.className = 'hp-dd__value';
        valueEl.textContent = initialValue || '';
        trigger.appendChild(valueEl);

        var caret = document.createElement('span');
        caret.className = 'hp-dd__caret';
        caret.setAttribute('aria-hidden', 'true');
        caret.innerHTML = '<svg viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        trigger.appendChild(caret);
        wrap.appendChild(trigger);

        var grid = document.createElement('div');
        // hp-dd__list de propina: es la misma clase que usa el desplegable
        // de Talla para posicionarse flotando debajo del botón (con su
        // fondo, borde y sombra) — así la rejilla no tiene que reinventar
        // ese posicionamiento, solo añade su propio grid de fotos encima.
        grid.className = 'hp-colorgrid hp-dd__list';
        // Mismo atributo que usa wireDropdown() para encontrar la lista a
        // abrir/cerrar — así la rejilla hereda gratis todo el comportamiento
        // de abrir al pulsar, cerrar al clicar fuera y cerrar con Escape.
        grid.setAttribute('data-hp-dd-list', '');
        grid.setAttribute('role', 'listbox');
        grid.setAttribute('aria-label', colorLabel);
        grid.hidden = true;

        var buttons = {};
        colorValues.forEach(function (val) {
          var rep = variants.filter(function (v) { return v.color === val; })[0];
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'hp-colorgrid__item';
          btn.setAttribute('role', 'option');
          btn.setAttribute('aria-label', val);
          btn.setAttribute('aria-selected', val === initialValue ? 'true' : 'false');
          if (val === initialValue) btn.classList.add('hp-active');
          if (rep && rep.image) {
            var img = document.createElement('img');
            img.src = rep.image;
            img.alt = val;
            img.loading = 'lazy';
            img.width = 90;
            img.height = 90;
            btn.appendChild(img);
          }
          btn.addEventListener('click', function () { onPick(val); });
          grid.appendChild(btn);
          buttons[val] = btn;
        });

        wrap.appendChild(grid);
        wireDropdown(wrap);

        return { wrap: wrap, trigger: trigger, valueEl: valueEl, thumbEl: thumbEl, buttons: buttons };
      }

      function markActiveGrid(grid, currentValue) {
        Object.keys(grid.buttons).forEach(function (val) {
          var isActive = val === currentValue;
          grid.buttons[val].classList.toggle('hp-active', isActive);
          grid.buttons[val].setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      function updateAddButton() {
        var allAvailable = units.length > 0 && units.every(function (u) { return u.variant && u.variant.available; });
        if (addBtn) {
          addBtn.disabled = !allAvailable;
          setAddLabel(addBtn, allAvailable ? (addBtn.dataset.labelAdd || 'Add to cart') : (addBtn.dataset.labelSoldout || 'Sold out'));
        }
        // El botón de "Agregar al carrito" propio de cada tarjeta (móvil)
        // tiene que reflejar el mismo estado que el real — si no hay
        // stock, que también se vea deshabilitado, no solo el de arriba.
        var mobileAddBtn = group.querySelector('.hp-unit__addcart');
        if (mobileAddBtn) {
          mobileAddBtn.disabled = !allAvailable;
          var mobileLabel = mobileAddBtn.querySelector('span');
          if (mobileLabel) {
            mobileLabel.textContent = allAvailable
              ? 'Agregar al carrito'
              : (addBtn ? (addBtn.dataset.labelSoldout || 'Sold out') : 'Sold out');
          }
        }
      }

      function refreshUnit(u, showInGallery) {
        var v = findVariant(u.color, u.talla);
        u.variant = v;
        u.colorGrid.valueEl.textContent = u.color;
        u.colorGrid.thumbEl.innerHTML = v && v.image ? '<img src="' + v.image + '" alt="" width="26" height="26" loading="lazy">' : '';
        u.tallaDD.valueEl.textContent = u.talla;
        markActiveGrid(u.colorGrid, u.color);
        markActive(u.tallaDD.list, u.talla);

        // El id y el precio del formulario los marca siempre la primera
        // unidad (las demás se añaden como líneas aparte al enviar).
        if (u.index === 0) {
          if (idInput && v) idInput.value = v.id;
          if (v) setAll(pricesNow, v.price);
        }

        // La foto grande, en cambio, sigue a CUALQUIER unidad que el
        // cliente esté tocando — no solo a la primera — para que al elegir
        // el color del 2º o 3º traje también se vea en la galería.
        if (showInGallery && gallery && gallery.hpShowImage && v && v.mediaId) {
          gallery.hpShowImage(v.mediaId);
        }

        updateAddButton();
      }

      // Construye N filas (Color + Talla) dentro de la tarjeta indicada.
      function buildUnitsInCard(container, qty) {
        container.innerHTML = '';
        units = [];
        var startColor = firstAvailableColor();

        for (var i = 0; i < qty; i++) {
          (function (index) {
            var color = startColor;
            var talla = firstAvailableTalla(color);

            var row = document.createElement('div');
            row.className = 'hp-unit';
            if (qty > 1) {
              var h = document.createElement('span');
              h.className = 'hp-unit__label';
              h.textContent = 'Traje ' + (index + 1);
              row.appendChild(h);
            }

            var u = { index: index, color: color, talla: talla, variant: null };
            var colorGrid = buildColorGrid(function (val) {
              u.color = val;
              // No pisar la talla que el cliente ya eligió: solo se cambia
              // si esa talla no existe (o no hay stock) para el color
              // nuevo. Antes siempre volvía a la primera talla disponible,
              // incluso cuando la talla elegida seguía siendo válida.
              var sigueValiendo = findVariant(val, u.talla);
              if (!sigueValiendo || !sigueValiendo.available) {
                u.talla = firstAvailableTalla(val);
              }
              refreshUnit(u, true);
            }, color);
            var tallaDD = buildDropdown('talla', function (val) {
              u.talla = val;
              // false: la talla no cambia la foto, así que no debe mover
              // la página hacia arriba (a diferencia del color).
              refreshUnit(u, false);
            }, talla);
            u.colorGrid = colorGrid;
            u.tallaDD = tallaDD;

            // Guía de tallas: justo encima del desplegable de Talla de
            // ESTA unidad (antes era un único botón suelto debajo de las
            // 3 tarjetas). Reutiliza el mismo panel flotante compartido
            // (data-hp-sizechart-modal) que ya vive una sola vez en el
            // DOM — aquí solo hace falta un botón más que lo abra.
            var scModal = box.querySelector('[data-hp-sizechart-modal]');
            if (scModal) {
              var scBtn = document.createElement('button');
              scBtn.type = 'button';
              scBtn.className = 'hp-unit__sizeguide';
              scBtn.innerHTML =
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h18v10H3z"/><path d="M7 7v3M11 7v3M15 7v3M19 7v3"/></svg>' +
                '<span>' + (group.dataset.sizechartLabel || 'Guía de tallas') + '</span>';
              scBtn.addEventListener('click', function () { scModal.hidden = !scModal.hidden; });
              row.appendChild(scBtn);
            }

            // Vuelve a ser exactamente como antes: el desplegable de Diseño
            // y el de Talla uno al lado del otro, cerrados los dos hasta
            // que el cliente pulsa uno — lo único que cambia es qué hay
            // DENTRO del desplegable de Diseño al abrirlo (la rejilla de
            // fotos, no una lista de nombres).
            var row2 = document.createElement('div');
            row2.className = 'hp-unit__row';
            row2.appendChild(colorGrid.wrap);
            row2.appendChild(tallaDD.wrap);
            row.appendChild(row2);

            container.appendChild(row);
            units.push(u);
            // false siempre: elegir una tarjeta (1/2/3 trajes) NO debe mover
            // la página hacia arriba, ni siquiera para la primera unidad —
            // solo debe subir cuando el cliente elige un modelo a propósito
            // desde la rejilla (eso lo dispara el propio onPick del
            // colorGrid, más arriba, no esta construcción inicial).
            refreshUnit(u, false);
          })(i);
        }

        // Botón de "Agregar al carrito" propio de esta tarjeta — UNA sola
        // vez, debajo de todas las filas (1, 2 o 3 trajes). Solo se ve en
        // móvil (CSS). Como vive dentro de container, que es el mismo
        // data-hp-offer-units que selectCard() esconde/enseña por tarjeta,
        // automáticamente solo aparece en la tarjeta activa sin lógica
        // aparte. No duplica el envío: reenvía el clic al botón real
        // (data-hp-add), que ya lleva todo el comportamiento (packs,
        // descuento, abrir carrito...).
        var addCartBtn = document.createElement('button');
        addCartBtn.type = 'button';
        addCartBtn.className = 'hp-unit__addcart';
        addCartBtn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
          '<span>Agregar al carrito</span>';
        addCartBtn.addEventListener('click', function () {
          if (addBtn) addBtn.click();
        });
        container.appendChild(addCartBtn);
      }

      group.hpGetCartItems = function () {
        var label = group.dataset.activeOfferLabel || '';
        return units
          .map(function (u) {
            if (!u.variant) return null;
            var item = { id: u.variant.id, quantity: 1 };
            // El guion bajo es el truco nativo de Shopify para "propiedad
            // oculta": sigue quedando anotada en el pedido (la ve el
            // dueño de la tienda en el admin), pero main-cart-items.liquid
            // ya no la pinta en el carrito del cliente (por eso salía
            // "Oferta: Compra 1" ahí, que no aportaba nada al comprador).
            if (label) item.properties = { '_Oferta': label };
            return item;
          })
          .filter(Boolean);
      };

      function parsePrice(text) {
        if (!text) return 0;
        var digits = text.replace(/[^0-9.,]/g, '').replace(/\.(?=.*\.)/g, '').replace(',', '.');
        return parseFloat(digits) || 0;
      }
      function formatPrice(amount) {
        var priceNow = box.querySelector('[data-hp-price-now]');
        var symbol = priceNow ? priceNow.textContent.replace(/[0-9.,\s]/g, '') : '$';
        return symbol + amount.toFixed(2);
      }
      function updatePrices() {
        var priceNow = box.querySelector('[data-hp-price-now]');
        basePrice = parsePrice(priceNow ? priceNow.textContent : '');
        // Los importes de data-discount-amount están fijados en dólares
        // (moneda de la tienda). Con monedas locales activadas, basePrice
        // ya viene convertido a euros/coronas/lo que sea para este
        // visitante — restarle el dólar en crudo daba un número sin
        // sentido. hp-producto.liquid calcula el tipo de cambio real que
        // Shopify ya está usando (comparando el precio convertido contra
        // el precio real en dólares) y lo deja en data-fx-rate; aquí solo
        // hay que multiplicar el descuento por ese número antes de
        // restarlo. Si no existe el atributo (tema viejo, o tienda sin
        // monedas locales), fxRate cae a 1 y se comporta como antes.
        var fxRate = parseFloat(group.dataset.fxRate);
        if (isNaN(fxRate) || fxRate <= 0) fxRate = 1;
        Array.prototype.forEach.call(offerCards, function (card) {
          var btn = card.querySelector('[data-hp-offer]');
          var qty = parseInt(btn.dataset.qty, 10) || 1;
          // Importe fijo (data-discount-amount) en vez de porcentaje: el
          // % de Shopify redondea internamente en el checkout (probado en
          // vivo: 12.49% sobre $63.98 daba $56.00 en vez de $55.99), así
          // que para que el total mostrado aquí sea IDÉNTICO al cobrado
          // en caja se resta un importe fijo, sin margen de redondeo.
          var amount = parseFloat(btn.dataset.discountAmount);
          var total;
          if (!isNaN(amount)) {
            total = (basePrice * qty) - (amount * fxRate);
          } else {
            var pct = parseFloat(btn.dataset.discountPct) || 0;
            total = basePrice * qty * (1 - pct / 100);
          }
          var out = btn.querySelector('[data-hp-offer-price]');
          if (out) out.textContent = formatPrice(total);
        });
      }

      var activeCode = '';

      function selectCard(card) {
        var btn = card.querySelector('[data-hp-offer]');
        var qty = parseInt(btn.dataset.qty, 10) || 1;
        activeCode = btn.dataset.discount || '';
        if (qtyInput) qtyInput.value = qty;
        group.dataset.activeDiscount = activeCode;
        // Se guarda el título de la tarjeta elegida ("1 traje" / "2 trajes —
        // 1+1 al 50%" / ...) para adjuntarlo como propiedad de línea al
        // añadir al carrito — así el carrito (y el pedido en Shopify) deja
        // claro de qué oferta viene cada unidad, no solo la talla/color.
        var labelEl = btn.querySelector('.hp-offer__text strong');
        group.dataset.activeOfferLabel = labelEl ? labelEl.textContent.trim() : '';

        Array.prototype.forEach.call(offerCards, function (c) {
          var cBtn = c.querySelector('[data-hp-offer]');
          var isActive = c === card;
          cBtn.classList.toggle('hp-active', isActive);
          cBtn.setAttribute('aria-checked', isActive ? 'true' : 'false');
          c.classList.toggle('hp-offer-card--active', isActive);
          var unitsBox = c.querySelector('[data-hp-offer-units]');
          if (unitsBox) {
            if (isActive) {
              unitsBox.hidden = false;
              buildUnitsInCard(unitsBox, qty);
            } else {
              unitsBox.hidden = true;
              unitsBox.innerHTML = '';
            }
          }
        });
      }

      Array.prototype.forEach.call(offerCards, function (card) {
        var btn = card.querySelector('[data-hp-offer]');
        btn.addEventListener('click', function () { selectCard(card); });
      });

      document.addEventListener('hp:variant:change', updatePrices);
      updatePrices();
      if (offerCards.length) selectCard(offerCards[0]);

      // Expuesto para que la barra CTA de fuera (hp-ctabar) pueda dejar
      // abierta la tarjeta de oferta que quiera sin duplicar esta lógica.
      group.hpSelectOfferByIndex = function (idx) {
        if (offerCards[idx]) selectCard(offerCards[idx]);
      };

      // Botón de guía de tallas: modal simple con la imagen.
      // El botón que la ABRE es el `.hp-unit__sizeguide` de cada fila,
      // creado en buildUnitsInCard() más arriba (que ya hace
      // `scModal.hidden = !scModal.hidden` directamente al pulsarlo) —
      // aquí solo falta enlazar el botón de CERRAR (la X) del propio panel,
      // que antes dependía de `[data-hp-sizechart-open]` (un atributo de
      // una versión anterior que ningún botón lleva ya), así que este
      // bloque nunca llegaba a ejecutarse y la X no cerraba nada.
      var scModal = box.querySelector('[data-hp-sizechart-modal]');
      if (scModal) {
        var scCloseBtns = scModal.querySelectorAll('[data-hp-sizechart-close]');
        Array.prototype.forEach.call(scCloseBtns, function (b) {
          b.addEventListener('click', function () { scModal.hidden = true; });
        });
      }
    });
  }

  /* ------------------------------------------------------------- Cantidad */

  function initQty() {
    var widgets = document.querySelectorAll('[data-hp-qty]');
    if (!widgets.length) return;

    Array.prototype.forEach.call(widgets, function (widget) {
      var input = widget.querySelector('input');
      var minus = widget.querySelector('[data-hp-qty-minus]');
      var plus = widget.querySelector('[data-hp-qty-plus]');
      if (!input) return;

      function nudge(delta) {
        var value = parseInt(input.value, 10);
        if (isNaN(value)) value = 1;
        input.value = Math.max(1, value + delta);
      }

      if (minus) minus.addEventListener('click', function () { nudge(-1); });
      if (plus) plus.addEventListener('click', function () { nudge(1); });

      input.addEventListener('change', function () {
        var value = parseInt(input.value, 10);
        if (isNaN(value) || value < 1) input.value = 1;
      });
    });
  }

  /* ------------------------------------------------- Carrusel de la portada */

  function initCarousel() {
    var carousels = document.querySelectorAll('[data-hp-carousel]');
    if (!carousels.length) return;
    Array.prototype.forEach.call(carousels, initOneCarousel);
  }

  function initOneCarousel(root) {
    var slides = root.querySelectorAll('.hp-carousel__slide');
    var dots = root.querySelectorAll('.hp-carousel__dot');
    var prev = root.querySelector('[data-hp-carousel-prev]');
    var next = root.querySelector('[data-hp-carousel-next]');
    if (slides.length < 2) return;

    var actual = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay === 'true' && !REDUCED;
    var intervalo = (parseFloat(root.dataset.interval) || 5) * 1000;

    function mostrar(i) {
      actual = (i + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) {
        slides[s].classList.toggle('hp-active', s === actual);
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('hp-active', d === actual);
        dots[d].setAttribute('aria-selected', d === actual ? 'true' : 'false');
      }
    }

    function arrancar() {
      if (!autoplay) return;
      parar();
      timer = window.setInterval(function () {
        mostrar(actual + 1);
      }, intervalo);
    }

    function parar() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    // Al tocar cualquier control, el pase automático se detiene: si el
    // visitante está mirando una foto concreta, no se la quitamos.
    function irA(i) {
      mostrar(i);
      autoplay = false;
      parar();
    }

    if (prev) prev.addEventListener('click', function () { irA(actual - 1); });
    if (next) next.addEventListener('click', function () { irA(actual + 1); });

    Array.prototype.forEach.call(dots, function (dot, i) {
      dot.addEventListener('click', function () { irA(i); });
    });

    // Deslizar con el dedo en móvil
    var x0 = null;
    root.addEventListener('pointerdown', function (e) { x0 = e.clientX; }, { passive: true });
    root.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 40) return;
      irA(dx < 0 ? actual + 1 : actual - 1);
    }, { passive: true });

    root.addEventListener('mouseenter', parar);
    root.addEventListener('mouseleave', arrancar);

    // No animar mientras la pestaña está en segundo plano
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar();
      else arrancar();
    });

    mostrar(0);
    arrancar();
  }

  /* ------------------------------------------------- Menú de cuenta (sin sesión) */

  function initAccountMenu() {
    var wrap = document.querySelector('[data-hp-account-menu]');
    if (!wrap) return;

    var trigger = wrap.querySelector('[data-hp-account-toggle]');
    var menu = wrap.querySelector('[data-hp-account-dropdown]');
    if (!trigger || !menu) return;

    function abrir() {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }
    function cerrar() {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (menu.hidden) abrir();
      else cerrar();
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) cerrar();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrar();
    });
  }

  /* ---------------------------------------------------- Carrito lateral */

  function initCartDrawer() {
    var root = document.querySelector('[data-hp-cart]');
    if (!root) return;

    var panel = root.querySelector('.hp-cart__panel');
    var itemsBox = root.querySelector('[data-hp-cart-items]');
    var emptyBox = root.querySelector('[data-hp-cart-empty]');
    var upsellBox = root.querySelector('[data-hp-cart-upsell]');
    var footBox = root.querySelector('[data-hp-cart-foot]');
    var countEl = root.querySelector('[data-hp-cart-count]');
    var subtotalEl = root.querySelector('[data-hp-cart-subtotal]');
    var moneyFormat = window.Shopify && Shopify.money_format ? Shopify.money_format : '${{amount}}';

    function formatMoney(cents) {
      // Formato mínimo compatible con el de la tienda, sin depender de un
      // helper externo: sustituye {{amount}} por el número con dos decimales.
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function abrir() {
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hp-cart-lock');
      // Se retrasa un instante para que el navegador pinte el estado
      // "hidden: false" antes de añadir la clase que dispara la transición
      // — si no, a veces aparece ya abierto de golpe, sin animar.
      // requestAnimationFrame no es fiable en todos los entornos (algunos
      // paneles/pestañas en segundo plano no lo disparan nunca), así que se
      // usa un temporizador corto en su lugar.
      window.setTimeout(function () {
        root.classList.add('hp-open');
      }, 20);
    }

    function cerrar() {
      root.classList.remove('hp-open');
      document.documentElement.classList.remove('hp-cart-lock');
      window.setTimeout(function () {
        root.hidden = true;
        root.setAttribute('aria-hidden', 'true');
      }, 400);
    }

    root.querySelectorAll('[data-hp-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', cerrar);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('hp-open')) cerrar();
    });

    function pintarBurbuja(count) {
      var bubble = document.querySelector('.cart-count-bubble');
      var cartLink = document.getElementById('cart-icon-bubble');
      if (!cartLink) return;

      if (count > 0) {
        if (bubble) {
          var span = bubble.querySelector('span[aria-hidden]');
          if (span) span.textContent = count;
        } else {
          var div = document.createElement('div');
          div.className = 'cart-count-bubble';
          div.innerHTML = '<span aria-hidden="true">' + count + '</span>';
          cartLink.appendChild(div);
        }
      } else if (bubble) {
        bubble.remove();
      }
    }

    function pintarCarrito(cart) {
      if (countEl) countEl.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
      pintarBurbuja(cart.item_count);

      if (cart.item_count === 0) {
        itemsBox.innerHTML = '';
        emptyBox.hidden = false;
        if (footBox) footBox.hidden = true;
        if (upsellBox) upsellBox.hidden = true;
        // Antes se quedaba abierto mostrando "Tu carrito está vacío" sin
        // ningún botón que sirviera de verdad para seguir — bug real en
        // móvil: al vaciar el carrito con la papelera, algunos caminos
        // acababan mandando a /cart (la página nativa de Shopify), que
        // enlaza "Seguir comprando" a TODOS los productos de la tienda,
        // incluidos otros antiguos sin relación. Más simple y sin ese
        // riesgo: en cuanto el carrito se queda a 0, se cierra solo y el
        // cliente vuelve a la página tal cual estaba, en la zona de compra.
        if (root.classList.contains('hp-open')) cerrar();
        return;
      }

      emptyBox.hidden = true;
      if (footBox) footBox.hidden = false;

      var html = '';
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        var variant = it.variant_title ? '<div class="hp-line__variant">' + escapeHtml(it.variant_title) + '</div>' : '';
        // La propiedad "Oferta" la pone initOffers() al añadir (1 traje / 2
        // trajes — 1+1 al 50% / 3 trajes — 2+1 gratis), así el carrito deja
        // claro de qué pack viene cada línea, no solo la variante.
        var offerLabel = '';
        if (it.properties) {
          for (var propKey in it.properties) {
            if (Object.prototype.hasOwnProperty.call(it.properties, propKey) && propKey.indexOf('_') !== 0 && it.properties[propKey]) {
              offerLabel = it.properties[propKey];
              break;
            }
          }
        }
        var offer = offerLabel ? '<div class="hp-line__offer">' + escapeHtml(offerLabel) + '</div>' : '';
        html +=
          '<article class="hp-line" data-hp-line="' + (i + 1) + '">' +
            '<a class="hp-line__media" href="' + it.url + '">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
            '</a>' +
            '<div class="hp-line__info">' +
              '<a class="hp-line__title" href="' + it.url + '">' + escapeHtml(it.product_title) + '</a>' +
              variant +
              offer +
              '<div class="hp-line__row">' +
                '<div class="hp-line__qty">' +
                  '<button type="button" data-hp-line-minus aria-label="Decrease quantity">&minus;</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button type="button" data-hp-line-plus aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<span class="hp-line__price">' + formatMoney(it.final_line_price) + '</span>' +
              '</div>' +
              '<button type="button" class="hp-line__remove" data-hp-line-remove>Remove</button>' +
            '</div>' +
          '</article>';
      }
      itemsBox.innerHTML = html;

      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      // El bloque "Añade otro traje" (tarjetas de oferta 1/2/3) se muestra
      // siempre que haya algo en el carrito — no depende de qué producto
      // sea, porque aquí solo se vende uno y siempre se puede añadir más.
      if (upsellBox) upsellBox.hidden = false;
    }

    function escapeHtml(s) {
      var div = document.createElement('div');
      div.textContent = s == null ? '' : String(s);
      return div.innerHTML;
    }

    function cargarCarrito() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          pintarCarrito(cart);
          return cart;
        });
    }

    function anadir(body) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    }

    // Aquí solo se vende un producto, así que "añadir" siempre sustituye a
    // lo que hubiera antes en vez de sumarse — bug real: comprar 1 traje,
    // volver y elegir el pack de 2 dejaba en el carrito 1 + 2 = 3 unidades
    // mezclando dos ofertas distintas (con el lío de descuentos que eso
    // arrastra, ver más abajo el `if false` del cajón). Vaciar antes de
    // cada /cart/add.js garantiza que el carrito refleja solo la última
    // elección del cliente.
    function anadirSustituyendo(body) {
      return fetch('/cart/clear.js', { method: 'POST' }).then(function () {
        return anadir(body);
      });
    }

    function cambiarLinea(linea, cantidad) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: linea, quantity: cantidad })
      }).then(function (r) { return r.json(); });
    }

    // Al cambiar de opción en un desplegable de venta cruzada, el botón de
    // añadir refleja si esa opción concreta está agotada. Escucha en
    // `document`, no en `root` (el carrito), porque el mismo patrón
    // `.hp-up` se reutiliza también en la venta cruzada de la ficha de
    // producto, fuera del carrito.
    document.addEventListener('change', function (e) {
      var select = e.target.closest('[data-hp-up-select]');
      if (!select) return;
      var card = select.closest('[data-hp-up]');
      var btn = card ? card.querySelector('[data-hp-up-add]') : null;
      var opcion = select.options[select.selectedIndex];
      if (btn && opcion) {
        btn.disabled = opcion.disabled;
        btn.textContent = opcion.disabled ? 'Sold out' : 'Add';
      }
    });

    // --- Delegación de eventos dentro del carrito -------------------------

    // El "+" responde al instante en pantalla y agrupa los clics seguidos en
    // una sola llamada de red (si no, cada clic espera la respuesta del
    // anterior y sumar varias unidades rápido se nota lento). El "-" se deja
    // exactamente como estaba: cada clic espera su respuesta del servidor.
    var temporizadoresMas = {};

    // También en `document`: el botón "Add" de `.hp-up` aparece tanto
    // dentro del carrito como en la venta cruzada de la ficha de producto.
    document.addEventListener('click', function (e) {
      var lineEl = e.target.closest('[data-hp-line]');
      if (lineEl) {
        var linea = parseInt(lineEl.dataset.hpLine, 10);
        var span = lineEl.querySelector('.hp-line__qty span');
        var actual = parseInt(span.textContent, 10);

        if (e.target.closest('[data-hp-line-plus]')) {
          var nueva = actual + 1;
          span.textContent = nueva;
          if (temporizadoresMas[linea]) window.clearTimeout(temporizadoresMas[linea]);
          temporizadoresMas[linea] = window.setTimeout(function () {
            delete temporizadoresMas[linea];
            cambiarLinea(linea, nueva).then(pintarCarrito);
          }, 260);
        } else if (e.target.closest('[data-hp-line-minus]')) {
          // El "−" nunca baja de 1: para quitar la línea entera está el
          // botón de la papelera (data-hp-line-remove), explícito. Antes
          // llegar a 0 con el "−" también vaciaba la línea sin avisar.
          if (actual > 1) cambiarLinea(linea, actual - 1).then(pintarCarrito);
        } else if (e.target.closest('[data-hp-line-remove]')) {
          cambiarLinea(linea, 0).then(pintarCarrito);
        }
        return;
      }

      var upBtn = e.target.closest('[data-hp-up-add]');
      if (upBtn && !upBtn.disabled) {
        var upCard = upBtn.closest('[data-hp-up]');
        var upSelect = upCard ? upCard.querySelector('[data-hp-up-select]') : null;
        var variantId = upSelect ? upSelect.value : upBtn.dataset.variantId;

        var textoOriginal = upBtn.textContent;
        upBtn.disabled = true;
        upBtn.textContent = 'Adding…';
        anadir({ id: variantId, quantity: 1 })
          .then(cargarCarrito)
          .then(function () {
            upBtn.textContent = 'Added';
            window.setTimeout(function () {
              upBtn.textContent = textoOriginal;
              upBtn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            upBtn.textContent = textoOriginal;
            upBtn.disabled = false;
          });
      }

      // Botón de la barra CTA de la ficha de producto ("Elegir color y
      // talla"): NO añade nada al carrito ni abre el cajón — sube a
      // #hp-buy-box y deja seleccionada/abierta la tarjeta de "2 trajes"
      // para que el cliente elija color y talla directamente ahí. El salto
      // de ancla nativo del propio href="#hp-buy-box" no desplaza nada en
      // este tema (probado: navegar directo a la URL con ese hash deja el
      // scroll en 0), así que el scroll lo hace este mismo JS a mano, con
      // e.preventDefault() para no dejar que el navegador lo intente aparte.
      var ctaBtn = e.target.closest('[data-hp-ctabar-add]');
      if (ctaBtn) {
        e.preventDefault();
        var offersGroup = document.querySelector('[data-hp-offers]');
        if (offersGroup && offersGroup.hpSelectOfferByIndex) {
          offersGroup.hpSelectOfferByIndex(1);
        }
        // 'auto' (salto instantáneo) y no 'smooth': la barra CTA vive muy
        // abajo en la página, y un scroll suave a tanta distancia se queda
        // arrastrándose durante minutos en este sitio (comprobado en vivo:
        // apenas avanza unos px cada varios segundos), probablemente por
        // algo que satura el hilo principal mientras tanto. Un salto
        // instantáneo es lo único fiable para un tramo tan largo.
        var buyBox = document.getElementById('hp-buy-box');
        if (buyBox) {
          buyBox.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      }
    });

    // --- Interceptar los formularios de compra de la tienda ---------------
    var formularios = ['#hp-hero-form', '#hp-product-form', '#hp-cart-offers-form'];
    formularios.forEach(function (sel) {
      var form = document.querySelector(sel);
      if (!form) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var addBtn = form.querySelector('[data-hp-add]');
        var textoOriginal = getAddLabel(addBtn);
        if (addBtn) {
          addBtn.disabled = true;
          setAddLabel(addBtn, 'Adding…');
        }

        var datos = new FormData(form);
        var buybox = form.closest('[data-hp-buybox]');
        var offerGroup = buybox ? buybox.querySelector('[data-hp-offers]') : null;
        var codigoDescuento = offerGroup ? offerGroup.dataset.activeDiscount : '';

        // Si hay selectores por unidad (1, 2 o 3 trajes con su propio color
        // y talla), se añade una línea por cada uno — pueden ser variantes
        // distintas. Si no, se cae al comportamiento normal de un solo id.
        var cuerpo;
        if (offerGroup && typeof offerGroup.hpGetCartItems === 'function') {
          var items = offerGroup.hpGetCartItems();
          cuerpo = items.length ? { items: items } : { id: datos.get('id'), quantity: datos.get('quantity') || 1 };
        } else {
          cuerpo = { id: datos.get('id'), quantity: datos.get('quantity') || 1 };
        }

        anadirSustituyendo(cuerpo)
          .then(function () {
            // Con oferta de 2 unidades: aplicamos el código real de Shopify
            // y llevamos directo al carrito para que el cliente vea el
            // precio con descuento ya aplicado, no solo en pantalla.
            if (codigoDescuento) {
              window.location.href = '/discount/' + encodeURIComponent(codigoDescuento) + '?redirect=/cart';
              return Promise.resolve();
            }
            return cargarCarrito().then(abrir);
          })
          .catch(function () {
            // Si algo falla (sin stock, etc.) no fingimos que ha ido bien:
            // dejamos que el navegador haga el envío normal como respaldo.
            form.submit();
          })
          .finally(function () {
            if (addBtn) {
              addBtn.disabled = false;
              setAddLabel(addBtn, textoOriginal);
            }
          });
      });
    });

    // El icono del carrito de la cabecera abre el panel en vez de ir a /cart
    var iconoCarrito = document.getElementById('cart-icon-bubble');
    if (iconoCarrito) {
      iconoCarrito.addEventListener('click', function (e) {
        e.preventDefault();
        cargarCarrito().then(abrir);
      });
    }

    // Botones de venta cruzada añadidos por otras secciones (por ejemplo la
    // barra de compra fija) también deben poder abrir el carrito.
    document.addEventListener('hp:cart:open', function () {
      cargarCarrito().then(abrir);
    });
  }

  /* ------------------------------------------------- Barra de compra fija */

  function initStickyBar() {
    var bar = document.querySelector('[data-hp-stickybar]');
    if (!bar) return;

    var box = document.querySelector('.hp-herobuy__box');
    var form = document.querySelector('#hp-hero-form');
    var addBtn = bar.querySelector('[data-hp-sticky-add]');
    if (!box || !form) return;

    bar.hidden = false;

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }

    var footer = document.querySelector('.footer');
    var ultimo = 0;

    function refresh() {
      // Visible solo cuando el cajón de compra de arriba ya no se ve, y se
      // retira al llegar al pie para no tapar el contenido final.
      var pasado = box.getBoundingClientRect().bottom < 60;
      var cercaDelFinal = footer
        ? footer.getBoundingClientRect().top < window.innerHeight
        : false;
      bar.classList.toggle('hp-visible', pasado && !cercaDelFinal);
    }

    // Cálculo directo y limitado por tiempo: no dependemos de
    // requestAnimationFrame, que algunos navegadores no disparan.
    function onScroll() {
      var ahora = Date.now();
      if (ahora - ultimo < 80) return;
      ultimo = ahora;
      refresh();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
    refresh();
  }

  /* ---------------------------------------------------------------- Arranque */

  /* ------------------------------------------- Popup de bienvenida */

  function initWelcomePopup() {
    var box = document.querySelector('[data-hp-welcome]');
    if (!box || box.dataset.hpReady) return;
    box.dataset.hpReady = '1';

    var endsAt = parseInt(box.dataset.hpWelcomeEnds, 10) * 1000;
    var code = box.dataset.hpWelcomeCode;
    var storageKey = 'hp-welcome-dismissed-' + code + '-' + box.dataset.hpWelcomeEnds;
    var countdownEl = box.querySelector('[data-hp-welcome-countdown]');
    var timer = null;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function fmt(ms) {
      var s = Math.max(0, Math.floor(ms / 1000));
      return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    }

    function tick() {
      var remaining = endsAt - Date.now();
      // Se acabó de verdad: se oculta y no vuelve, ni recargando.
      if (remaining <= 0) {
        cerrar();
        window.clearInterval(timer);
        return;
      }
      if (countdownEl) countdownEl.textContent = fmt(remaining);
    }

    function cerrar() {
      box.classList.remove('is-visible');
      window.setTimeout(function () { box.hidden = true; }, 250);
    }

    function descartar() {
      cerrar();
      try { window.localStorage.setItem(storageKey, '1'); } catch (err) { /* modo privado */ }
    }

    box.querySelectorAll('[data-hp-welcome-close]').forEach(function (btn) {
      btn.addEventListener('click', descartar);
    });
    box.addEventListener('click', function (e) {
      if (e.target === box) descartar();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) descartar();
    });

    var copyBtn = box.querySelector('[data-hp-welcome-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var hecho = function () {
          var original = copyBtn.textContent;
          copyBtn.textContent = 'Copied';
          copyBtn.classList.add('is-copied');
          window.setTimeout(function () {
            copyBtn.textContent = original;
            copyBtn.classList.remove('is-copied');
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(hecho).catch(hecho);
        } else {
          hecho();
        }
      });
    }

    var yaCerrado = false;
    try { yaCerrado = window.localStorage.getItem(storageKey) === '1'; } catch (err) { /* modo privado */ }
    if (yaCerrado) return;

    // Ya expiró antes de cargar la página: ni se muestra.
    if (endsAt - Date.now() <= 0) return;

    // Sale al instante. Los 20 ms le dan al navegador un momento para pintar
    // "hidden: false" antes de añadir la clase que anima la entrada — si se
    // hace en el mismo tick, el fundido no se ve. Se usa temporizador y no
    // requestAnimationFrame por lo mismo que ya está anotado en el carrito:
    // hay entornos donde rAF no se dispara nunca.
    box.hidden = false;
    tick();
    timer = window.setInterval(tick, 1000);
    window.setTimeout(function () { box.classList.add('is-visible'); }, 20);
  }

  /* ------------------------- Enlaces internos con desplazamiento suave */

  function initSmoothAnchors() {
    var links = document.querySelectorAll('[data-hp-smooth]');
    if (!links.length) return;

    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        if (!id || id.charAt(0) !== '#') return;
        var destino = document.querySelector(id);
        if (!destino) return;
        e.preventDefault();
        destino.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---- Botón de volver en las páginas de política (envío, devoluciones,
     privacidad, términos) ---------------------------------------------- */

  function initPolicyBackLink() {
    // Estas 4 páginas son las únicas de la tienda que Shopify sirve con su
    // propia plantilla fija de sistema (.shopify-policy__container) sin
    // pasar por ninguna sección del tema — no existe ningún archivo de
    // sección donde meter esto por Liquid (se probó con
    // templates/policy.liquid + una sección propia y Shopify las ignoró
    // por completo, sin error). Por eso se añade aquí, por JS.
    var container = document.querySelector('.shopify-policy__container');
    if (!container) return;

    // El título que muestra Shopify en estas 4 páginas viene fijo en
    // inglés (no respeta el título en español guardado en la política) —
    // se traduce aquí según la URL, que es fija para cada una.
    var titulos = {
      '/policies/shipping-policy': 'Política de envío',
      '/policies/refund-policy': 'Política de reembolso',
      '/policies/privacy-policy': 'Política de privacidad',
      '/policies/terms-of-service': 'Términos del servicio'
    };
    var ruta = window.location.pathname.replace(/\/$/, '');
    // Puede llevar el prefijo del idioma (/es/policies/...) — se compara
    // por el final de la ruta, no por igualdad exacta. Ojo: hay que
    // comprobar primero que `ruta` sea al menos tan larga como `clave`,
    // si no, cuando ninguna de las dos aparece (indexOf da -1 en ambos
    // lados) la comparación puede dar un falso positivo.
    var tituloNuevo = null;
    for (var clave in titulos) {
      if (ruta.length >= clave.length && ruta.slice(ruta.length - clave.length) === clave) {
        tituloNuevo = titulos[clave];
        break;
      }
    }
    if (tituloNuevo) {
      var h1 = container.querySelector('.shopify-policy__title h1');
      if (h1) h1.textContent = tituloNuevo;
    }

    // El botón de volver: en la página de preguntas frecuentes (y contacto)
    // ya lo pinta la propia sección main-page.liquid como hermano ANTES de
    // este contenedor, así que hay que mirar en toda la página, no solo
    // dentro de .shopify-policy__container, o sale duplicado.
    if (document.querySelector('.hp-pagelink-back')) return;

    var a = document.createElement('a');
    a.className = 'hp-pagelink-back';
    a.href = '/';
    a.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>' +
      '<span>Volver al traje</span>';
    container.parentNode.insertBefore(a, container);
  }

  /* ------------------ Selector de moneda: recordar la elección -------- */

  function initCurrencySwitch() {
    // En cuanto el visitante pulsa € o $ a propósito, se marca con esta
    // cookie para que theme.liquid deje de forzar dólares por defecto en
    // sus próximas visitas (ver el bloque en <head> que la comprueba).
    // Un año de duración: de sobra para "recordar" una elección así.
    document.addEventListener('click', function (e) {
      if (e.target.closest('.hp-currency-switch__btn')) {
        document.cookie = 'hp_currency_choice=1; max-age=31536000; path=/';
      }
    });
  }

  /* ------------------ Cuenta atrás del descuento de bienvenida -------- */

  function initWelcomeCountdown() {
    var boxes = document.querySelectorAll('[data-hp-welcome-countdown]');
    if (!boxes.length) return;

    // El descuento BIENVENIDA5 en sí no caduca — lo que se reinicia aquí es
    // solo el reloj visual, guardado por visitante en localStorage. Si a
    // alguien se le agota, en vez de dejarlo en 00:00:00 le arranca una
    // cuenta nueva, para que "termina en X horas" esté siempre activo tal
    // como se pidió, en vez de quedarse parado en cero.
    //
    // La duración de cada cuenta nueva se sortea entre 1h30 y 3h30 (no
    // siempre las mismas 2h exactas) — si no, cualquiera que probara desde
    // varias sesiones nuevas vería siempre el mismo "02:00:00" de salida,
    // delatando que el plazo no es real.
    var DURACION_MIN_MS = 1.5 * 60 * 60 * 1000;
    var DURACION_MAX_MS = 3.5 * 60 * 60 * 1000;
    var CLAVE = 'hp_welcome_deadline';

    function duracionAleatoria() {
      return DURACION_MIN_MS + Math.random() * (DURACION_MAX_MS - DURACION_MIN_MS);
    }

    function obtenerLimite() {
      var guardado = parseInt(localStorage.getItem(CLAVE), 10);
      var ahora = Date.now();
      if (!guardado || guardado <= ahora) {
        guardado = ahora + duracionAleatoria();
        localStorage.setItem(CLAVE, guardado);
      }
      return guardado;
    }

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function formatear(ms) {
      var totalSeg = Math.max(0, Math.floor(ms / 1000));
      var h = Math.floor(totalSeg / 3600);
      var m = Math.floor((totalSeg % 3600) / 60);
      var s = totalSeg % 60;
      return pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    function actualizar() {
      var limite = obtenerLimite();
      var restante = limite - Date.now();
      if (restante <= 0) {
        localStorage.removeItem(CLAVE);
        limite = obtenerLimite();
        restante = limite - Date.now();
      }
      var texto = formatear(restante);
      boxes.forEach(function (box) {
        var timer = box.querySelector('[data-hp-countdown-timer]');
        if (timer) timer.textContent = texto;
      });
    }

    actualizar();
    setInterval(actualizar, 1000);
  }

  /* ------------------ Botón flotante de volver a la zona de compra ---- */

  function initBackToTop() {
    var btn = document.querySelector('[data-hp-backtop]');
    var zona = document.querySelector('[data-hp-buysection]');
    if (!btn || !zona) return;

    // Aparece cuando la zona de compra ya ha quedado por encima de la
    // pantalla, que es justo el punto donde empieza la banda oscura de
    // frases que va inmediatamente después.
    function revisar() {
      var pasada = zona.getBoundingClientRect().bottom < 0;
      if (pasada) {
        if (btn.hidden) {
          btn.hidden = false;
          // Igual que el resto de overlays: dejar que pinte hidden:false
          // antes de animar. rAF no es fiable en este proyecto.
          window.setTimeout(function () { btn.classList.add('is-visible'); }, 20);
        }
      } else if (!btn.hidden) {
        btn.classList.remove('is-visible');
        window.setTimeout(function () {
          if (!btn.classList.contains('is-visible')) btn.hidden = true;
        }, 300);
      }
    }

    btn.addEventListener('click', function () {
      zona.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    });

    window.addEventListener('scroll', revisar, { passive: true });
    window.addEventListener('resize', revisar);
    revisar();
  }

  /* ------------------------------------------------- Reseñas reales: cargar más */

  function initRealReviews() {
    var groups = document.querySelectorAll('[data-hp-realr-grid]');
    Array.prototype.forEach.call(groups, function (grid) {
      var btn = grid.parentElement.querySelector('[data-hp-realr-more]');
      if (!btn) return;
      var step = parseInt(btn.dataset.step, 10) || 6;

      btn.addEventListener('click', function () {
        var hidden = grid.querySelectorAll('.hp-realr__card[hidden]');
        for (var i = 0; i < hidden.length && i < step; i++) {
          hidden[i].hidden = false;
        }
        if (grid.querySelectorAll('.hp-realr__card[hidden]').length === 0) {
          btn.hidden = true;
        }
      });
    });
  }

  /* ------------------------------------------------- Escribir una reseña */

  function initReviewModal() {
    var modal = document.querySelector('[data-hp-review-modal]');
    var openBtns = document.querySelectorAll('[data-hp-review-open]');
    if (!modal || !openBtns.length) return;

    var form = modal.querySelector('#hp-review-form');
    var steps = modal.querySelectorAll('[data-hp-review-step]');
    var starBtns = modal.querySelectorAll('[data-hp-review-stars] .hp-review-stars-pick__star');
    var nextBtns = modal.querySelectorAll('[data-hp-review-next]');
    var backBtns = modal.querySelectorAll('[data-hp-review-back]');
    var closeBtns = modal.querySelectorAll('[data-hp-review-close]');
    var contentEl = modal.querySelector('[data-hp-review-content]');
    var emailEl = modal.querySelector('[data-hp-review-email]');
    var nameEl = modal.querySelector('[data-hp-review-name]');
    var nameField = modal.querySelector('[data-hp-review-name-field]');
    var anonBtn = modal.querySelector('[data-hp-review-anon]');
    var photoEl = modal.querySelector('[data-hp-review-photo]');
    var dropzone = modal.querySelector('[data-hp-review-dropzone]');
    var dropzoneText = modal.querySelector('[data-hp-review-dropzone-text]');
    var dropzoneDefaultText = dropzoneText ? dropzoneText.textContent : '';
    var emailHidden = modal.querySelector('[data-hp-review-email-hidden]');
    var bodyHidden = modal.querySelector('[data-hp-review-body-hidden]');

    var state = { stars: 0, anon: false };

    function showStep(n) {
      Array.prototype.forEach.call(steps, function (s) {
        s.hidden = parseInt(s.dataset.hpReviewStep, 10) !== n;
      });
    }

    function open() {
      modal.hidden = false;
      document.body.classList.add('hp-no-scroll');
      showStep(1);
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove('hp-no-scroll');
      // Se deja lista para una siguiente reseña, sin arrastrar datos.
      window.setTimeout(function () {
        if (form) form.reset();
        state.stars = 0;
        state.anon = false;
        Array.prototype.forEach.call(starBtns, function (b) { b.classList.remove('is-on'); });
        var nextInStep1 = modal.querySelector('[data-hp-review-step="1"] [data-hp-review-next]');
        if (nextInStep1) nextInStep1.disabled = true;
        if (anonBtn) anonBtn.checked = false;
        if (nameField) nameField.hidden = false;
        if (dropzone) dropzone.classList.remove('has-file');
        if (dropzoneText) dropzoneText.textContent = dropzoneDefaultText;
        showStep(1);
      }, 300);
    }

    Array.prototype.forEach.call(openBtns, function (b) { b.addEventListener('click', open); });
    Array.prototype.forEach.call(closeBtns, function (b) { b.addEventListener('click', close); });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    // Paso 1: estrellas
    Array.prototype.forEach.call(starBtns, function (btn) {
      btn.addEventListener('click', function () {
        state.stars = parseInt(btn.dataset.value, 10);
        Array.prototype.forEach.call(starBtns, function (b) {
          b.classList.toggle('is-on', parseInt(b.dataset.value, 10) <= state.stars);
        });
        var nextInStep1 = modal.querySelector('[data-hp-review-step="1"] [data-hp-review-next]');
        if (nextInStep1) nextInStep1.disabled = false;
      });
    });

    // Anónimo: casilla — oculta el campo de nombre y recuerda la elección
    if (anonBtn) {
      anonBtn.addEventListener('change', function () {
        state.anon = anonBtn.checked;
        if (nameField) nameField.hidden = state.anon;
        if (nameEl) nameEl.value = '';
      });
    }

    // Foto: la propia casilla es un <label> del input de archivo, así que
    // el selector se abre solo. Aquí solo se refleja qué se eligió.
    if (photoEl && dropzone) {
      photoEl.addEventListener('change', function () {
        var file = photoEl.files && photoEl.files[0];
        dropzone.classList.toggle('has-file', !!file);
        if (dropzoneText) dropzoneText.textContent = file ? file.name : dropzoneDefaultText;
      });
    }

    Array.prototype.forEach.call(nextBtns, function (btn) {
      btn.addEventListener('click', function () {
        var current = btn.closest('[data-hp-review-step]');
        var n = parseInt(current.dataset.hpReviewStep, 10);
        if (n === 2 && contentEl && !contentEl.value.trim()) {
          contentEl.focus();
          return;
        }
        showStep(n + 1);
      });
    });

    Array.prototype.forEach.call(backBtns, function (btn) {
      btn.addEventListener('click', function () {
        var current = btn.closest('[data-hp-review-step]');
        var n = parseInt(current.dataset.hpReviewStep, 10);
        showStep(n - 1);
      });
    });

    // Red de seguridad: si por lo que sea el formulario recibe un submit
    // nativo (por ejemplo, tecla Enter en algún navegador), se bloquea
    // aquí también. El envío de verdad SOLO pasa por el clic de abajo.
    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); });
    }

    var submitBtn = modal.querySelector('[data-hp-review-submit]');
    if (submitBtn && form) {
      submitBtn.addEventListener('click', function () {
        if (emailEl && !emailEl.value.trim()) {
          emailEl.focus();
          return;
        }

        // Compone un único mensaje legible para el correo que recibe la
        // tienda: no hay app de reseñas conectada, así que esto es lo que
        // de verdad se envía y alguien del equipo lo publica a mano.
        var estrellas = state.stars ? Array(state.stars + 1).join('★') + Array(6 - state.stars).join('☆') : 'Sin puntuación';
        var nombre = state.anon ? 'Anónimo' : ((nameEl && nameEl.value.trim()) || 'Anónimo');
        var partes = [
          'Nueva reseña de producto',
          'Puntuación: ' + estrellas + ' (' + state.stars + '/5)',
          'Nombre a mostrar: ' + nombre,
          '',
          (contentEl && contentEl.value.trim()) || ''
        ];
        if (photoEl && photoEl.files && photoEl.files[0]) {
          partes.push('');
          partes.push('Aviso: el cliente quiso adjuntar una foto (' + photoEl.files[0].name + '), pero este formulario no admite archivos — contactar para pedírsela si hace falta.');
        }

        if (bodyHidden) bodyHidden.value = partes.join('\n');
        if (emailHidden && emailEl) emailHidden.value = emailEl.value.trim();

        var textoOriginal = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Enviando…';

        // Nunca form.submit() ni type="submit": el botón es type="button" y
        // el envío va SOLO por fetch, así no hay manera de que el
        // navegador navegue de verdad a /contact y refresque la página.
        fetch(form.action, { method: 'POST', body: new FormData(form) })
          .then(function () {
            showStep(4);
          })
          .catch(function () {
            showStep(4);
          })
          .finally(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = textoOriginal; }
          });
      });
    }
  }

  function boot() {
    initReveals();
    initHero();
    initCounters();
    initCompare();
    initGallery();
    initVideoWallSound();
    initProductReviews();
    initVariants();
    initOffers();
    initQty();
    initCurrencySwitch();
    initWelcomeCountdown();
    initCarousel();
    initStickyBar();
    initCartDrawer();
    initAccountMenu();
    initWelcomePopup();
    initSmoothAnchors();
    initPolicyBackLink();
    initBackToTop();
    initRealReviews();
    initReviewModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
